import apiAction from "../ajax/service";

export const getRentals = async (input , page = 1) => {
    const data = await apiAction(
          "filters",
          {
            field:"rental.name,description,images,type,defaultAmount,totalUnits",
            limit:100,
              page,
            filters: {
              withKey: true,
              [`name__contains`]: input,

            },
          },
          "getUniqueInField"
    );
    return data
}

export const setRentalCache = async (rentals , id=-1 ) => {
    const data = await apiAction(
          "productpage",
          {
            id,
            rentalsCache:rentals
          },
          "update"
    );
    return data
}

export const getProductPageConfig = async () => {
    const data = await apiAction(
          "productpage",
          {},
          "custom"
    );
    return data
}
export const setProductPageConfig = async (config , id=-1) => {
    const data = await apiAction(
          "productpage",
          {id, config },
          "update"
    );
    return data
}
export const updateRentalCache = async ()=>{
     const data = await apiAction(
          "productpage",
          {},
          "updateCache"
    );
    return data
}
